import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import SuccessImage from 'shared/images/excursions-success.png'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

const SuccessPage = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onClick = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  return (
    <div className={clsx('container', 'safe-area-top-padding', s.container)}>
      <div className={s.content}>
        <img
          src={SuccessImage}
          className={s.successImage}
          alt=""
        />

        <div className={s.text}>
          <h3 className={s.title}>{t('excursions.done')}</h3>
          <p className={clsx(s.description, 'medium-16')}>
            {t('excursions.success_description')}
          </p>
        </div>

        <div className={s.btnContainer}>
          <Button
            variant="grey"
            onClick={onClick}
          >
            <span className={clsx(s.buttonText, 'bold-16')}>
              {t('excursions.my_orders')}
            </span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SuccessPage
